/* New Main Product JS - Compatible with iOS 10+ */

document.addEventListener('DOMContentLoaded', function() {
  var sliders = document.querySelectorAll('[data-product-slider]');

  for (var s = 0; s < sliders.length; s++) {
    (function(mainSliderEl) {
      if (!mainSliderEl || typeof BlazeSlider === 'undefined') return;

      var mainSlider = new BlazeSlider(mainSliderEl, {
        all: {
          slidesToShow: 1,
          slideGap: '0px',
          loop: true,
          enableAutoplay: false,
          slidesToScroll: 1,
          transitionDuration: 300,
          enablePagination: true
        }
      });

      initThumbnailNavigation(mainSliderEl);
      bindGallerySync(mainSliderEl, mainSlider);
    })(sliders[s]);
  }

  initImageLightbox();
});

function bindGallerySync(mainSliderEl, mainSlider) {
  var customThumbnails = mainSliderEl.querySelectorAll('.custom-thumbnail');
  var progressBar = mainSliderEl.querySelector('.progress-bar');
  var progressBarFill = progressBar ? progressBar.querySelector('.progress-bar__fill') : null;
  var paginationContainer = mainSliderEl.querySelector('.blaze-pagination');
  var track = mainSlider.track;
  var slideNodes = track.querySelectorAll('.new-product__slide');
  var slideIds = [];
  var indexById = {};
  var pendingIndex = null;
  var resizeTimer = null;

  if (slideNodes.length === 0) return;

  for (var i = 0; i < slideNodes.length; i++) {
    var id = slideNodes[i].getAttribute('data-slide-index');
    if (id === null || id === '') {
      id = String(i);
      slideNodes[i].setAttribute('data-slide-index', id);
    }
    slideIds.push(id);
    indexById[id] = i;
  }

  function logicalIndex() {
    if (!mainSlider.states || !mainSlider.states.length) return 0;
    var state = mainSlider.states[mainSlider.stateIndex] || mainSlider.states[0];
    return state.page[0];
  }

  function isRestingConsistent() {
    if (mainSlider.offset !== 0) return true;
    var first = track.querySelector('.new-product__slide');
    if (!first) return true;
    var logical = logicalIndex();
    return String(first.getAttribute('data-slide-index')) === String(slideIds[logical]);
  }

  function updateProgressBar(activeIndex) {
    if (progressBarFill && slideIds.length > 0) {
      var progress = ((activeIndex + 1) / slideIds.length) * 100;
      progressBarFill.style.width = progress + '%';
    }
  }

  function updateThumbnailsState(positionalIndex) {
    var activeId = slideIds[positionalIndex];
    var activeThumb = null;

    for (var t = 0; t < customThumbnails.length; t++) {
      var thumbId = customThumbnails[t].getAttribute('data-slide-index');
      var isActive = String(thumbId) === String(activeId);
      customThumbnails[t].classList.toggle('is-active', isActive);
      if (isActive) {
        customThumbnails[t].setAttribute('aria-current', 'true');
        activeThumb = customThumbnails[t];
      } else {
        customThumbnails[t].removeAttribute('aria-current');
      }
    }

    if (window.innerWidth >= 1024 && activeThumb) {
      var thumbnailContainer = mainSliderEl.querySelector('[data-thumbnail-container]');
      if (thumbnailContainer) {
        var containerRect = thumbnailContainer.getBoundingClientRect();
        var thumbRect = activeThumb.getBoundingClientRect();
        if (thumbRect.top < containerRect.top || thumbRect.bottom > containerRect.bottom) {
          activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    }

    updateProgressBar(positionalIndex);
  }

  function syncPagination(positionalIndex) {
    if (!paginationContainer) return;
    var buttons = paginationContainer.querySelectorAll('button');
    for (var b = 0; b < buttons.length; b++) {
      if (b === positionalIndex) buttons[b].classList.add('active');
      else buttons[b].classList.remove('active');
    }
  }

  function visiblePositionalIndex() {
    var container = mainSliderEl.querySelector('.blaze-track-container') || track;
    var containerRect = container.getBoundingClientRect();
    var slides = track.querySelectorAll('.new-product__slide');
    var fallback = 0;

    for (var n = 0; n < slides.length; n++) {
      var slideId = slides[n].getAttribute('data-slide-index');
      var positional = indexById[slideId];
      if (n === 0 && positional !== undefined) fallback = positional;
      var rect = slides[n].getBoundingClientRect();
      if (rect.left >= containerRect.left - 10 && rect.left <= containerRect.left + 10 && positional !== undefined) {
        return positional;
      }
    }

    return fallback;
  }

  function repairToVisible() {
    var visible = visiblePositionalIndex();
    var slides = Array.prototype.slice.call(track.children);
    var byId = {};

    for (var n = 0; n < slides.length; n++) {
      byId[slides[n].getAttribute('data-slide-index')] = slides[n];
    }

    var rotated = [];
    for (var p = 0; p < slideIds.length; p++) {
      var pos = (visible + p) % slideIds.length;
      if (byId[slideIds[pos]]) rotated.push(byId[slideIds[pos]]);
    }

    for (var r = 0; r < rotated.length; r++) {
      track.appendChild(rotated[r]);
    }

    mainSlider.stateIndex = visible;
    mainSlider.offset = 0;
    mainSlider.dragged = 0;
    track.style.transitionDuration = '0ms';
    track.style.transform = 'translate3d(0px, 0px, 0px)';
    track.offsetHeight;
    track.style.transitionDuration = mainSlider.config.transitionDuration + 'ms';
    syncPagination(visible);
    updateThumbnailsState(visible);
  }

  function goTo(targetIndex) {
    if (targetIndex === undefined || targetIndex === null || isNaN(targetIndex)) return;
    if (targetIndex < 0 || targetIndex >= slideIds.length) return;

    if (mainSlider.isTransitioning) {
      pendingIndex = targetIndex;
      updateThumbnailsState(targetIndex);
      return;
    }

    if (!isRestingConsistent()) {
      repairToVisible();
    }

    var current = logicalIndex();
    if (current === targetIndex) {
      updateThumbnailsState(targetIndex);
      syncPagination(targetIndex);
      return;
    }

    var total = mainSlider.states.length;
    var diff = Math.abs(targetIndex - current);
    var inverseDiff = total - diff;
    var scrollOpposite = mainSlider.config.loop && diff > total / 2;

    pendingIndex = null;
    updateThumbnailsState(targetIndex);

    if (targetIndex > current) {
      if (scrollOpposite) mainSlider.prev(inverseDiff);
      else mainSlider.next(diff);
    } else if (scrollOpposite) {
      mainSlider.next(inverseDiff);
    } else {
      mainSlider.prev(diff);
    }
  }

  function syncFromPagination() {
    if (!isRestingConsistent() || !paginationContainer) return;
    var buttons = paginationContainer.querySelectorAll('button');
    for (var b = 0; b < buttons.length; b++) {
      if (buttons[b].classList.contains('active')) {
        updateThumbnailsState(b);
        return;
      }
    }
  }

  for (var t = 0; t < customThumbnails.length; t++) {
    (function(thumbnail) {
      thumbnail.addEventListener('click', function(e) {
        e.preventDefault();
        var thumbId = thumbnail.getAttribute('data-slide-index');
        var positional = indexById[thumbId];
        if (positional === undefined) return;
        goTo(positional);
      });
    })(customThumbnails[t]);
  }

  if (typeof mainSlider.onSlide === 'function') {
    mainSlider.onSlide(function(stateIndex, firstSlideIndex) {
      if (pendingIndex !== null && pendingIndex !== firstSlideIndex) {
        var nextTarget = pendingIndex;
        pendingIndex = null;
        goTo(nextTarget);
        return;
      }
      pendingIndex = null;
      updateThumbnailsState(firstSlideIndex);
    });
  }

  if (paginationContainer) {
    var observer = new MutationObserver(function() {
      syncFromPagination();
    });
    observer.observe(paginationContainer, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function ensureConsistent() {
    if (!mainSlider.isTransitioning && mainSlider.offset === 0 && !isRestingConsistent()) {
      repairToVisible();
    }
  }

  track.addEventListener('pointerdown', ensureConsistent, true);
  track.addEventListener('touchstart', ensureConsistent, true);

  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(ensureConsistent, 350);
  });

  updateThumbnailsState(logicalIndex());
}

function initThumbnailNavigation(root) {
  var scope = root || document;
  var thumbnailContainer = scope.querySelector('[data-thumbnail-container]');
  var arrowUp = scope.querySelector('.thumbnail-arrow-up');
  var arrowDown = scope.querySelector('.thumbnail-arrow-down');

  if (!thumbnailContainer || !arrowUp || !arrowDown) return;
  if (thumbnailContainer.getAttribute('data-thumbs-ready') === 'true') return;
  thumbnailContainer.setAttribute('data-thumbs-ready', 'true');

  var thumbnails = thumbnailContainer.querySelectorAll('.custom-thumbnail');
  if (thumbnails.length === 0) return;

  var getScrollAmount = function() {
    var thumbHeight = thumbnails[0].offsetHeight;
    var gap = parseFloat(getComputedStyle(thumbnailContainer).gap) || 12;
    return thumbHeight + gap;
  };

  var updateArrowsState = function() {
    var isAtTop = thumbnailContainer.scrollTop <= 0;
    var isAtBottom = thumbnailContainer.scrollTop + thumbnailContainer.clientHeight >= thumbnailContainer.scrollHeight - 1;

    arrowUp.disabled = isAtTop;
    arrowDown.disabled = isAtBottom;
  };

  arrowUp.addEventListener('click', function(e) {
    e.preventDefault();
    thumbnailContainer.scrollBy({
      top: -getScrollAmount(),
      behavior: 'smooth'
    });
  });

  arrowDown.addEventListener('click', function(e) {
    e.preventDefault();
    thumbnailContainer.scrollBy({
      top: getScrollAmount(),
      behavior: 'smooth'
    });
  });

  thumbnailContainer.addEventListener('scroll', updateArrowsState);
  updateArrowsState();
  window.addEventListener('resize', updateArrowsState);
}

function initImageLightbox() {
  var lightboxes = document.querySelectorAll('.product-image-lightbox');
  if (lightboxes.length === 0) return;

  for (var lb = 0; lb < lightboxes.length; lb++) {
    (function(lightbox) {
      var sectionEl = lightbox.closest('.new-product');
      if (!sectionEl) return;

      var viewport = lightbox.querySelector('[data-lightbox-viewport]');
      var image = lightbox.querySelector('[data-lightbox-image]');
      var loader = lightbox.querySelector('[data-lightbox-loader]');
      var closeBtn = lightbox.querySelector('.product-image-lightbox__close');
      var thumbnails = lightbox.querySelectorAll('.product-image-lightbox__thumbnail');
      var zoomRange = lightbox.querySelector('[data-lightbox-zoom-range]');
      var currentIndex = 0;
      var loadToken = 0;
      var isOpen = false;
      var pan = { x: 0, y: 0, scale: 1 };
      var drag = { active: false, startX: 0, startY: 0, panStartX: 0, panStartY: 0 };

      function setLoading(isLoading) {
        if (isLoading) {
          lightbox.classList.add('is-loading');
          lightbox.setAttribute('aria-busy', 'true');
          if (loader) {
            loader.hidden = false;
            loader.setAttribute('aria-hidden', 'false');
          }
        } else {
          lightbox.classList.remove('is-loading');
          lightbox.setAttribute('aria-busy', 'false');
          if (loader) {
            loader.hidden = true;
            loader.setAttribute('aria-hidden', 'true');
          }
        }
      }

      function getSlideImageByIndex(index) {
        var slides = sectionEl.querySelectorAll('[data-zoom-container] img[data-zoom-image]');
        for (var i = 0; i < slides.length; i++) {
          var slideIndex = parseInt(slides[i].getAttribute('data-slide-index'), 10);
          if (slideIndex === index) {
            return slides[i];
          }
        }
        return null;
      }

      function getActiveSlideIndex() {
        var trackEl = sectionEl.querySelector('.blaze-track');
        if (trackEl) {
          var container = trackEl.parentElement || trackEl;
          var trackRect = container.getBoundingClientRect();
          var containers = trackEl.querySelectorAll('[data-zoom-container]');
          for (var i = 0; i < containers.length; i++) {
            var rect = containers[i].getBoundingClientRect();
            if (rect.left >= trackRect.left - 10 && rect.left <= trackRect.left + 10) {
              var visibleIndex = parseInt(containers[i].getAttribute('data-slide-index'), 10);
              if (!isNaN(visibleIndex)) return visibleIndex;
            }
          }
        }

        var activeThumb = sectionEl.querySelector('.custom-thumbnail.is-active');
        if (activeThumb) {
          var thumbIndex = parseInt(activeThumb.getAttribute('data-slide-index'), 10);
          if (!isNaN(thumbIndex)) return thumbIndex;
        }

        return 0;
      }

      function getScaleLimits() {
        var vw = viewport.clientWidth;
        var vh = viewport.clientHeight;
        var iw = image.naturalWidth;
        var ih = image.naturalHeight;
        var minScale = Math.min(vw / iw, vh / ih);
        var maxScale = 1;

        if (minScale > maxScale) {
          maxScale = minScale;
        }

        return { min: minScale, max: maxScale };
      }

      function sliderToScale(value, limits) {
        return limits.min + (limits.max - limits.min) * (value / 100);
      }

      function scaleToSlider(scale, limits) {
        if (limits.max === limits.min) return 0;
        return ((scale - limits.min) / (limits.max - limits.min)) * 100;
      }

      function syncZoomRange() {
        if (!zoomRange) return;
        var limits = getScaleLimits();
        zoomRange.value = scaleToSlider(pan.scale, limits);
      }

      function setZoom(scale, pivotX, pivotY) {
        var vw = viewport.clientWidth;
        var vh = viewport.clientHeight;
        var limits = getScaleLimits();

        scale = Math.max(limits.min, Math.min(limits.max, scale));
        pivotX = pivotX !== undefined ? pivotX : vw / 2;
        pivotY = pivotY !== undefined ? pivotY : vh / 2;

        var imageX = (pivotX - pan.x) / pan.scale;
        var imageY = (pivotY - pan.y) / pan.scale;

        pan.scale = scale;
        pan.x = pivotX - imageX * pan.scale;
        pan.y = pivotY - imageY * pan.scale;
        constrainPan();
        applyTransform();
        syncZoomRange();
      }

      function updateThumbnails() {
        for (var t = 0; t < thumbnails.length; t++) {
          var thumbIndex = parseInt(thumbnails[t].getAttribute('data-lightbox-thumb-index'), 10);
          if (thumbIndex === currentIndex) {
            thumbnails[t].classList.add('is-active');
            thumbnails[t].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          } else {
            thumbnails[t].classList.remove('is-active');
          }
        }
      }

      function constrainPan() {
        var vw = viewport.clientWidth;
        var vh = viewport.clientHeight;
        var iw = image.naturalWidth * pan.scale;
        var ih = image.naturalHeight * pan.scale;
        var minX;
        var maxX;
        var minY;
        var maxY;

        if (iw >= vw) {
          minX = vw - iw;
          maxX = 0;
        } else {
          minX = maxX = (vw - iw) / 2;
        }

        if (ih >= vh) {
          minY = vh - ih;
          maxY = 0;
        } else {
          minY = maxY = (vh - ih) / 2;
        }

        pan.x = Math.max(minX, Math.min(maxX, pan.x));
        pan.y = Math.max(minY, Math.min(maxY, pan.y));
      }

      function applyTransform() {
        image.style.transform = 'translate(' + pan.x + 'px, ' + pan.y + 'px) scale(' + pan.scale + ')';
      }

      function resetPan() {
        var vw = viewport.clientWidth;
        var vh = viewport.clientHeight;
        var iw = image.naturalWidth;
        var ih = image.naturalHeight;

        if (!iw || !ih) return;

        var limits = getScaleLimits();
        pan.scale = limits.min;
        pan.x = (vw - iw * pan.scale) / 2;
        pan.y = (vh - ih * pan.scale) / 2;
        constrainPan();
        applyTransform();
        syncZoomRange();
      }

      function loadImage(index) {
        var srcImg = getSlideImageByIndex(index);
        if (!srcImg) return;

        var newSrc = srcImg.getAttribute('data-zoom-image') || srcImg.src;
        var token = ++loadToken;

        currentIndex = index;
        image.alt = srcImg.alt || '';
        updateThumbnails();
        setLoading(true);

        function finishLoad() {
          if (token !== loadToken) return;
          resetPan();
          setLoading(false);
        }

        image.onload = finishLoad;
        image.onerror = function() {
          if (token !== loadToken) return;
          setLoading(false);
        };

        if (image.src === newSrc && image.complete && image.naturalWidth) {
          finishLoad();
          return;
        }

        image.src = newSrc;

        if (image.complete && image.naturalWidth) {
          finishLoad();
        }
      }

      function open(index) {
        isOpen = true;
        lightbox.setAttribute('aria-hidden', 'false');
        lightbox.classList.add('is-open');
        document.body.classList.add('product-lightbox-open');
        loadImage(index);
      }

      function close() {
        isOpen = false;
        drag.active = false;
        loadToken += 1;
        setLoading(false);
        viewport.classList.remove('is-dragging');
        lightbox.setAttribute('aria-hidden', 'true');
        lightbox.classList.remove('is-open');
        document.body.classList.remove('product-lightbox-open');
      }

      function onPointerDown(e) {
        if (!isOpen || e.button > 0) return;

        drag.active = true;
        drag.startX = e.clientX;
        drag.startY = e.clientY;
        drag.panStartX = pan.x;
        drag.panStartY = pan.y;
        viewport.classList.add('is-dragging');

        if (viewport.setPointerCapture) {
          viewport.setPointerCapture(e.pointerId);
        }
      }

      function onPointerMove(e) {
        if (!drag.active) return;

        pan.x = drag.panStartX + (e.clientX - drag.startX);
        pan.y = drag.panStartY + (e.clientY - drag.startY);
        constrainPan();
        applyTransform();
      }

      function onPointerUp(e) {
        if (!drag.active) return;

        drag.active = false;
        viewport.classList.remove('is-dragging');

        if (viewport.releasePointerCapture) {
          try {
            viewport.releasePointerCapture(e.pointerId);
          } catch (err) {}
        }
      }

      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        close();
      });

      document.addEventListener('keydown', function(e) {
        if (isOpen && e.key === 'Escape') {
          close();
        }
      });

      viewport.addEventListener('pointerdown', onPointerDown);
      viewport.addEventListener('pointermove', onPointerMove);
      viewport.addEventListener('pointerup', onPointerUp);
      viewport.addEventListener('pointercancel', onPointerUp);

      if (zoomRange) {
        zoomRange.addEventListener('input', function() {
          var limits = getScaleLimits();
          var newScale = sliderToScale(parseFloat(zoomRange.value), limits);
          setZoom(newScale);
        });
      }

      for (var t = 0; t < thumbnails.length; t++) {
        (function(thumb) {
          thumb.addEventListener('click', function(e) {
            e.preventDefault();
            var index = parseInt(thumb.getAttribute('data-lightbox-thumb-index'), 10);
            if (!isNaN(index)) {
              loadImage(index);
            }
          });
        })(thumbnails[t]);
      }

      var zoomableSlides = sectionEl.querySelectorAll('.new-product__slide--zoomable');
      for (var s = 0; s < zoomableSlides.length; s++) {
        (function(slide) {
          var slideImg = slide.querySelector('img[data-zoom-image]');
          if (!slideImg) return;

          slideImg.addEventListener('click', function(e) {
            e.preventDefault();
            var index = parseInt(slide.getAttribute('data-slide-index'), 10);
            if (isNaN(index)) index = getActiveSlideIndex();
            open(index);
          });
        })(zoomableSlides[s]);
      }

      var zoomButtons = sectionEl.querySelectorAll('.zoom-icon-trigger');
      for (var b = 0; b < zoomButtons.length; b++) {
        (function(button) {
          button.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var index = parseInt(button.getAttribute('data-slide-index'), 10);
            if (isNaN(index)) index = getActiveSlideIndex();
            open(index);
          });
        })(zoomButtons[b]);
      }

      window.addEventListener('resize', function() {
        if (isOpen && zoomRange) {
          var sliderValue = parseFloat(zoomRange.value);
          var limits = getScaleLimits();
          setZoom(sliderToScale(sliderValue, limits));
        }
      });

      var track = sectionEl.querySelector('.blaze-track');
      if (track) {
        var observer = new MutationObserver(function() {
          updateVisibleZoomIcon();
        });

        observer.observe(track, {
          attributes: true,
          attributeFilter: ['style']
        });
      }

      function updateVisibleZoomIcon() {
        var trackEl = sectionEl.querySelector('.blaze-track');
        if (!trackEl) return;

        var slides = trackEl.querySelectorAll('[data-zoom-container]');
        var trackRect = trackEl.getBoundingClientRect();

        for (var i = 0; i < slides.length; i++) {
          var slideEl = slides[i];
          var rect = slideEl.getBoundingClientRect();
          var button = slideEl.querySelector('.zoom-icon-trigger');

          if (button) {
            if (rect.left >= trackRect.left - 10 && rect.left <= trackRect.left + 10) {
              button.classList.remove('zoom-icon-hidden');
            } else {
              button.classList.add('zoom-icon-hidden');
            }
          }
        }
      }

      updateVisibleZoomIcon();
    })(lightboxes[lb]);
  }
}
